export default function PolicePersonnelDetails () {
    return (
    <div>

<div className="police-bg bg-image">
            <div className="gap-spacer"></div>
            <div className="page-title mobile-center-title top-cap-outlines">
                <h1>Morrisville Borough Police</h1>
            </div>
            {/*Start Main Content*/}
            <div className="police-center-container mid-side-outlines">
                
                           
                {/*Start Police Sub-Menu*/}
                <div className="police-sub-menu">
                    <div className="logo"></div>
                    <input className="menu-btn" type="checkbox" id="menu-btn"/>
                    <label className="menu-icon" for="menu-btn"><i className="fa-solid fa-bars"></i>&nbsp;Police Sub-Menu</label>
                    <ul className="menu">
                        <li><a href="/police">General</a></li>
                        <li><a href="https://bucks.crimewatchpa.com/morrisvillepd/34776">CrimeWatch&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                        <li><a href="/police/documents">Documents</a></li>
                        <li><a href="/police/jobs">Jobs</a></li>
                        <li><a href="/police/personnel">Personnel</a></li>
                        <li><a href="/police/resources">Resources</a></li>
                        <li><a href="https://bucks.crimewatchpa.com/morrisvillepd/34776/submit-tip">Submit-A-Tip&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                        <li><a href="/police/statistics">Statistics</a></li>
                    </ul>
                </div>
                {/*End Police Sub-Menu*/}


                <div className="police-center-container mobile-pad-1em ">

<div className="police-960-col-100p">
    <br/>
    <h4>Personnel</h4>
    <div className="officer-profile">
        <img src="../img/personnel/rich-ciampa.jpg" alt="Chief Rich Ciampa" width="50%" height="auto"/>
        <div className="officer-info">
        <h3>Chief Rich Ciampa<br/>Badge #81</h3>
        <p>
            <a href="mailto:r.ciampa@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp;r.ciampa@morrisvillepolice.org</a>
        </p>
        <p>
            Chief Rich Ciampa is a self-described forward-thinking police administrator with 25 years of law enforcement experience. He began his Police career as an Officer at the Freehold Borough Police Department, was promoted to Sergeant in 2012 and then promoted to Lieutenant in 2019. He has a strong background in personnel development, community relations, and strategic policing. His leadership has led to improvements in patrol division operations, policy development, and internal investigation protocols. He has also actively participated in budget planning and special event coordination, demonstrating his adeptness in managing complex operational tasks and fostering community engagement.
        </p>
        <p>
            Chief Ciampa attended and graduated with a Bachelor of Arts Degree from Fairleigh Dickenson University in 2023. He has certifications and achievements from the Rutgers University Certified Public Manager Program, Internal Affairs, Firearms Instructor-Active Shooter Instructor, Monmouth County Police Academy Instructor and FEMA Incident Command Systems.
        </p>
        </div>
        <hr/>
    </div>

    <div className="officer-profile">

        <img src="../img/personnel/lew-halas.jpg" alt="Officer Halas"/>
        <div className="officer-info">
        <h3>CPL. Lew Halas<br/>Badge #23</h3>
        <p>
            <a href="mailto:l.halas@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp;l.halas@morrisvillepolice.org</a>
        </p>
        </div>
        <hr/>
    </div>
    
    
    <div className="officer-profile">

        <img src="../img/personnel/Carlin.jpg" alt="Officer Carlin"/>
        <div className="officer-info">
        <h3>OFC. Christopher Carlin<br/>Badge #17</h3>
        <p>
            <a href="mailto:c.carlin@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp;c.carlin@morrisvillepolice.org</a>
        </p>
        </div>
        <hr/>
    </div>
    <div className="officer-profile">

        <img src="../img/personnel/Chrzanowski.jpg" alt="Officer Chrzanowski"/>
        <div className="officer-info">
        <h3>OFC. Dominic Chrzanowski<br/>Badge #27</h3>
        <p>
            <a href="mailto:d.chrzanowski@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp;d.chrzanowski@morrisvillepolice.org</a>
        </p>
        </div>
        <hr/>
    </div>
    
    <div className="officer-profile">

        <img src="../img/personnel/deluca.jpg" alt="Officer Deluca"/>
        <div className="officer-info">
        <h3>OFC. Amanda DeLuca<br/>Badge #28</h3>
        <p>
                <a href="mailto:a.deluca@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp;a.deluca@morrisvillepolice.org</a>
        </p>
        </div>
        <hr/>
    </div>
    
    <div className="officer-profile">

        <img src="../img/personnel/michael_dilanni.jpeg" alt="Officer Dilanni"/>
        <div className="officer-info">
        <h3>OFC. Michael DiIanni<br/>Badge #16</h3>
        <p>
                    <a href="mailto:m.diianni@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp;m.diianni@morrisvillepolice.org</a>
        </p>
        </div>
        <hr/>
    </div>

      <div className="officer-profile">

        <img src="../img/personnel/kdipaolo.jpg" alt="Officer DiPaolo"/>
        <div className="officer-info">
        <h3>OFC. Kevin DiPaolo<br/>Badge #30</h3>
        <p>
                    <a href="mailto:k.dipaolo@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp;k.dipaolo@morrisvillepolice.org</a>
        </p>
        </div>
        <hr/>
    </div>
    
    <div className="officer-profile">

        <img src="../img/personnel/eiler.png" alt="Officer Eiler"/>
        <div className="officer-info">
        <h3>OFC. Owen Eiler<br/>Badge #25</h3>
        <p>
                <a href="mailto:o.eiler@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp;o.eiler@morrisvillepolice.org</a>
        </p>
        </div>
        <hr/>
    </div>

     <div className="officer-profile">

        <img src="../img/personnel/morse.jpg" alt="Officer Morse"/>
        <div className="officer-info">
        <h3>OFC. Matthew Morse <br/>Badge #31</h3>
        <p>
                    <a href="mailto:m.morse@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp;m.morse@morrisvillepolice.org</a>
        </p>
        </div>
        <hr/>
    </div>
    
    
    <div className="officer-profile">

        <img src="../img/personnel/parell.jpg" alt="Officer Parell"/>
        <div className="officer-info">
        <h3>OFC. Joseph Parell IV<br/>Badge #26</h3>
        <p>
                    <a href="mailto:j.parell@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp;j.parell@morrisvillepolice.org</a>
        </p>
        </div>
        <hr/>
    </div>
    
    <div className="officer-profile">

        <img src="../img/personnel/smelter.png" alt="Officer Smelter"/>
        <div className="officer-info">
        <h3>OFC. Brad Smeltzer<br/>Badge #07</h3>
        <p>
                    <a href="mailto:b.smeltzer@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp;b.smeltzer@morrisvillepolice.org</a>
        </p>
        </div>
        <hr/>
    </div>
    
        <div className="officer-profile">

        <img src="../img/personnel/williamson.png" alt="Officer Williamson"/>
        <div className="officer-info">
        <h3>OFC. Michelle Williamson<br/>Badge #24</h3>
        <p>
                        <a href="mailto:m.williamson@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp;m.williamson@morrisvillepolice.org</a>
        </p>
        </div>
        <hr/>
    </div>
<h2>Staff Members</h2>
        {/*
        <div className="officer-profile">
        <div className="officer-info">
        <h3>Cathy Breza</h3>
        <p>
                        <a href="mailto:c.breza@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp;c.breza@morrisvillepolice.org</a>
        </p>
        </div>
        <hr/>
    </div>
    */}
    
    <div className="officer-profile">

    
        <div className="officer-info">
        <h3>Nicole Tiberio</h3>
        <p>
                        <a href="mailto: n.tiberio@morrisvillepolice.org"><i className="fa-regular fa-envelope"></i>&nbsp; n.tiberio@morrisvillepolice.org</a>
        </p>
        </div>
        <hr/>
    </div>

</div>
    

</div>


</div>
<div className="page-footer bottom-cap-outlines">&nbsp;</div>
<div className="gap-spacer"></div>








                
                </div>
                </div>
    )
}
